import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Trainee Profile Information")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = {
  key: 0,
  class: "border-top pt-9"
}
const _hoisted_8 = {
  key: 0,
  id: "trainee_profile"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "profile-info pt-1 pb-1" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-sm-3" }
const _hoisted_13 = { class: "thumbnail" }
const _hoisted_14 = {
  href: "javascript:;",
  class: "",
  title: "Entity Logo"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "col-sm-9" }
const _hoisted_17 = { class: "table-responsive" }
const _hoisted_18 = { class: "table" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Registration Number")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Reference Number")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Name")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Gender")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Father Name")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mother Name")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "National ID")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Birth Certificate Number")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date of Birth")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Home District")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Present Address")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Permanent Address")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mobile")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Alternative Mobile")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Email")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Religion")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Highest Class Completed")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Attendance Percentage ")
], -1)
const _hoisted_37 = { class: "block" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h4", null, "Training Information", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_40 = { class: "table-responsive" }
const _hoisted_41 = { class: "table" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training Partner")
], -1)
const _hoisted_43 = ["href"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training Institute")
], -1)
const _hoisted_45 = ["href"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Course")
], -1)
const _hoisted_47 = ["href"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Batch")
], -1)
const _hoisted_49 = ["href"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training Start Date")
], -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training End Date")
], -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training Duration")
], -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training Completed")
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Tranche")
], -1)
const _hoisted_55 = { class: "block" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("h4", null, "Assessment Information", -1)
const _hoisted_57 = { class: "table" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", { width: "200" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Assessment Date")
], -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("td", { width: "100" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Assessor")
], -1)
const _hoisted_60 = { class: "block" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("h4", null, "Certification Information", -1)
const _hoisted_62 = { class: "table" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", { width: "200" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Certification Date")
], -1)
const _hoisted_64 = { class: "block mt-4" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h4", null, "Employment Information", -1)
const _hoisted_66 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"border-bottom":"1px solid #23ce10"} }, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Employer Name"),
    /*#__PURE__*/_createElementVNode("th", null, "From"),
    /*#__PURE__*/_createElementVNode("th", null, "To"),
    /*#__PURE__*/_createElementVNode("th", null, "Duration"),
    /*#__PURE__*/_createElementVNode("th", null, "Monthly Income"),
    /*#__PURE__*/_createElementVNode("th", null, "Employment Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Employment Status")
  ])
], -1)
const _hoisted_68 = { style: {} }
const _hoisted_69 = { class: "text-start" }
const _hoisted_70 = { class: "text-start" }
const _hoisted_71 = { class: "text-start" }
const _hoisted_72 = { class: "text-start" }
const _hoisted_73 = { class: "text-start" }
const _hoisted_74 = { class: "text-start" }
const _hoisted_75 = { class: "text-start" }
const _hoisted_76 = { class: "text-start" }
const _hoisted_77 = {
  key: 1,
  class: "text-center"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("h4", null, "No data found!", -1)
const _hoisted_79 = [
  _hoisted_78
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.showTraineeInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_ctx.traineeInfo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("h2", null, "Profile of " + _toDisplayString(_ctx.traineeInfo.trainee_name), 1),
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("a", _hoisted_14, [
                                  _createElementVNode("img", {
                                    class: "d-flex justify-content-center h-100 w-100",
                                    src: 
                              _ctx.traineeInfo?.attach_file_info
                                ? _ctx.api_url +
                                  _ctx.traineeInfo?.attach_file_info?.file_path
                                : 'media/avatars/blank.png'
                            ,
                                    alt: ""
                                  }, null, 8, _hoisted_15)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("table", _hoisted_18, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_19,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.registration_number), 1),
                                      _hoisted_20,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.reference_number), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_21,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.trainee_name), 1),
                                      _hoisted_22,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.gender), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_23,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.father_name), 1),
                                      _hoisted_24,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.mother_name), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_25,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.nid), 1),
                                      _hoisted_26,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.bcn), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_27,
                                      _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo.date_of_birth
                                    ? _ctx.moment(_ctx.traineeInfo.date_of_birth).format(
                                        'DD-MM-YYYY'
                                      )
                                    : ''), 1),
                                      _hoisted_28,
                                      _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo.home_district_info
                                    .district_name_eng), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_29,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.present_address), 1),
                                      _hoisted_30,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.per_address), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_31,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.mobile), 1),
                                      _hoisted_32,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.alternative_mobile), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_33,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.email), 1),
                                      _hoisted_34,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.religion), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_35,
                                      _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo.highest_class_completed), 1),
                                      _hoisted_36,
                                      _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo.attendance_percentage), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _hoisted_38,
                            _hoisted_39,
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("table", _hoisted_41, [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_42,
                                    _createElementVNode("td", null, [
                                      _createTextVNode(" : "),
                                      _createElementVNode("a", {
                                        href: 
                                  `${this.VUE_APP_TMS}/association/entity-list/` +
                                  _ctx.entity_id
                                ,
                                        class: "form_link",
                                        "data-search-type": "entity",
                                        "data-search-key": "26",
                                        target: "_blank",
                                        title: "Training Partner"
                                      }, _toDisplayString(_ctx.traineeInfo?.entity_info?.entity_name), 9, _hoisted_43)
                                    ]),
                                    _hoisted_44,
                                    _createElementVNode("td", null, [
                                      _createTextVNode(" : "),
                                      _createElementVNode("a", {
                                        href: 
                                  `${this.VUE_APP_TMS}/training-institute/institute-list/` +
                                  _ctx.training_institute_id
                                ,
                                        target: "_blank",
                                        class: "form_link",
                                        "data-search-type": "institute",
                                        "data-search-key": "",
                                        title: "Training Institute"
                                      }, _toDisplayString(_ctx.traineeInfo?.institute_info?.institute_name), 9, _hoisted_45)
                                    ]),
                                    _hoisted_46,
                                    _createElementVNode("td", null, [
                                      _createTextVNode(" : "),
                                      _createElementVNode("a", {
                                        target: "_blank",
                                        href: 
                                  `${this.VUE_APP_TMS}/course/course-detail/` +
                                  _ctx.course_info_id
                                ,
                                        class: "form_link",
                                        "data-search-type": "course",
                                        "data-search-key": "",
                                        title: "Training Course"
                                      }, _toDisplayString(_ctx.traineeInfo?.course_info?.course_name), 9, _hoisted_47)
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_48,
                                    _createElementVNode("td", null, [
                                      _createTextVNode(" : "),
                                      _createElementVNode("a", {
                                        href: 
                                  `${this.VUE_APP_TMS}/course-batch/view/` +
                                  _ctx.batch_info_id
                                ,
                                        class: "form_link",
                                        "data-search-type": "batch",
                                        "data-search-key": "2005",
                                        title: "Batch Number",
                                        target: "_blank"
                                      }, _toDisplayString(_ctx.traineeInfo?.batch_info?.batch_sequence_number), 9, _hoisted_49)
                                    ]),
                                    _hoisted_50,
                                    _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo?.batch_info?.start_date
                                  ? _ctx.moment(
                                      _ctx.traineeInfo?.batch_info?.start_date
                                    ).format('DD-MM-YYYY')
                                  : ''), 1),
                                    _hoisted_51,
                                    _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo?.batch_info?.end_date
                                  ? _ctx.moment(
                                      _ctx.traineeInfo?.batch_info?.end_date
                                    ).format('DD-MM-YYYY')
                                  : ''), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_52,
                                    _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo?.course_info?.month) + " months ", 1),
                                    _hoisted_53,
                                    _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.course_info?.day) + " days", 1),
                                    _hoisted_54,
                                    _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfo?.tranche_info?.label), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _hoisted_56,
                            _createElementVNode("table", _hoisted_57, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _hoisted_58,
                                  _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo?.training_assessment?.assessment_date
                                ? _ctx.moment(
                                    _ctx.traineeInfo.training_assessment
                                      .assessment_date
                                  ).format('DD-MM-YYYY')
                                : ''), 1),
                                  _hoisted_59,
                                  _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo?.training_assessment?.assessor
                                ?.employee_info?.name), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _hoisted_61,
                            _createElementVNode("table", _hoisted_62, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _hoisted_63,
                                  _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfo?.training_certificate
                                ?.certification_date
                                ? _ctx.moment(
                                    _ctx.traineeInfo?.training_certificate
                                      ?.certification_date
                                  ).format('DD-MM-YYYY')
                                : ''), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _hoisted_65,
                            _createElementVNode("table", _hoisted_66, [
                              _hoisted_67,
                              _createElementVNode("tbody", _hoisted_68, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.traineeInfo?.trainee_employment, (info, key) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: key,
                                    class: "border border-gray-400 text-center"
                                  }, [
                                    _createElementVNode("td", _hoisted_69, _toDisplayString(key + 1), 1),
                                    _createElementVNode("td", _hoisted_70, _toDisplayString(info?.organization_name), 1),
                                    _createElementVNode("td", _hoisted_71, _toDisplayString(info?.joining_date
                                  ? _ctx.moment(info?.joining_date).format(
                                      'DD-MM-YYYY'
                                    )
                                  : ''), 1),
                                    _createElementVNode("td", _hoisted_72, _toDisplayString(info?.release_date
                                  ? _ctx.moment(info?.release_date).format(
                                      'DD-MM-YYYY'
                                    )
                                  : ''), 1),
                                    _createElementVNode("td", _hoisted_73, _toDisplayString(info?.release_date
                                  ? Math.floor(
                                      (new Date(info?.release_date) -
                                        new Date(info?.joining_date)) /
                                        (1000 * 60 * 60 * 24 * 365)
                                    )
                                  : Math.floor(
                                      (new Date() -
                                        new Date(info?.joining_date)) /
                                        (1000 * 60 * 60 * 24 * 365)
                                    )) + " years ", 1),
                                    _createElementVNode("td", _hoisted_74, _toDisplayString(info?.salary), 1),
                                    _createElementVNode("td", _hoisted_75, _toDisplayString(info?.employment_type == 1
                                  ? 'Self Employment'
                                  : info?.employment_type == 2
                                  ? 'Wages Employment'
                                  : 'UpSkill Employment'), 1),
                                    _createElementVNode("td", _hoisted_76, _toDisplayString(info?.employment_status == 1
                                  ? 'Running'
                                  : 'Completed'), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_77, _hoisted_79))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ]))
}